/**
 * Obowiązki przeciwpożarowe dla fotowoltaiki ponad 6,5 kW (art. 29 ust. 4 pkt 3 lit. c Prawa
 * budowlanego, tekst jednolity Dz.U. 2026 poz. 524): przed montażem uzgodnienie projektu
 * z rzeczoznawcą do spraw zabezpieczeń przeciwpożarowych, po montażu zawiadomienie PSP
 * z planem urządzenia dla ekip ratowniczych.
 *
 * Próg liczymy po mocy MODUŁÓW (kWp): tak robią PSP i rzeczoznawcy, ustawa mówi tylko
 * o „mocy zainstalowanej elektrycznej”. Dokładnie 6,5 kWp jeszcze nie podlega.
 *
 * Gdy powstanie narzędzie do zawiadomienia PSP (PLAN_ZAWIADOMIENIE_PSP.md), linkujemy do niego
 * obok artykułu.
 */
export const PROG_PPOZ_KWP = 6.5

export const ARTYKUL_PPOZ = {
  href: '/baza-wiedzy/fotowoltaika-powyzej-6-5-kw-ppoz-zawiadomienie-psp',
  tytul: 'Fotowoltaika powyżej 6,5 kW i straż pożarna',
}

export const wymagaPpoz = (kwp) => Number(kwp) > PROG_PPOZ_KWP
